// extracted by mini-css-extract-plugin
module.exports = {"base":"button_base__hGZG9","inverted":"button_inverted__2HrVg","large":"button_large__4qzEW"};